<template>
  <v-container class="">

    <v-card
        max-width="550"
        class="mx-auto loginWrap"
        color="#17202fba"
    >
      <v-card-title class="pt-5 justify-center">
        <div class="">
          <div class="text-center">
            <v-img
                alt="Vuetify Logo"
                class="mx-auto mainLogo"
                contain
                src="@/assets/img/logo_big.png"
                transition="scale-transition"
                width="400"
            />

          </div>

          <h5 class="font-weight-regular text-center">
            로그인 후 이용하실 수 있습니다.
          </h5>
        </div>


      </v-card-title>
      <v-card-text class="px-16 py-9">
        <validation-observer
            ref="boardWriteForm"
            v-slot="{ invalid }"
        >
          <form
              class=""
              @submit.prevent="login"
          >
            <v-row class="ma-0">
              <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  class="pa-0 mb-2"
              >
                <validation-provider
                    v-slot="{ errors }"
                    name="userId"
                    rules="required"
                >
                  <v-text-field
                      v-model="userId"
                      label="아이디"
                      outlined
                      required
                      name="userId"
                      class="rounded-0 searchInput"
                      background-color="#252F41"
                      :error-messages="errors"
                      hide-details
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  class="pa-0 mb-2"
              >
                <validation-provider
                    v-slot="{ errors }"
                    name="userPassword"
                    rules="required"
                >
                  <v-text-field
                      v-model="userPassword"
                      label="비밀번호"
                      :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="passwordShow ? 'text' : 'password'"
                      @click:append="passwordShow = !passwordShow"
                      outlined
                      required
                      name="userPassword"
                      class="rounded-0 searchInput"
                      background-color="#252F41"
                      :error-messages="errors"
                      hide-details
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <div class="mb-4">
              <v-btn
                  tile
                  color="#289CAF"
                  class=""
                  block
                  x-large
                  type="submit"
                  :disabled="invalid"
              >
                로그인
              </v-btn>
            </div>
            <div class="text-right">
              <v-subheader
                class="px-0 justify-end"

                @click="openJoinDialog"
              >
                회원가입
              </v-subheader>
            </div>
          </form>


        </validation-observer>
      </v-card-text>
    </v-card>

    <under-maintenance-dialog
        :dialog.sync=dialog.underMaintenance
        :text=dialog.underMaintenanceText
    ></under-maintenance-dialog>

    <join-dialog
        v-if="dialog.join"
        :joinDialog.sync="dialog.join"
    />
    <v-overlay
        absolute
        z-index="999"
        :value="loading">
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
// import axios from "axios";
import {eventBus} from "@/plugins/eventBus";
import JoinDialog from '@/components/Member/JoinDialog.vue'

export default {
  name: "MemberLogin",
  data: () => ({
    loading: false,
    userId: '',
    userPassword: '',
    passwordShow: false,
    dialog: {
      recommender: false,
      alert: false,
      alertText: '',
      alertActionType: '',
      alertOption: {
        persistent: false
      },
      underMaintenance: false,
      underMaintenanceText: '',
      snackBar: false,
      snackBarText: '',
      join: false,
      joinData: {}
    },
  }),
  components: {
    JoinDialog
  },
  methods: {

    openJoinDialog : function () {
      this.dialog.join = true
    },

    showAlert: function () {
      eventBus.showAlert(this.dialog.alertText, this.dialog.alertOption, this.dialog.alertActionType)
    },
    login: function () {
      const username = this.userId;
      const password = this.userPassword;

      if (!username || !password) {
        return false;
      }
      this.$store
          .dispatch("LOGIN", {username, password})
          .then(() => {
            this.$router.push({name: "main"});
          })
          .catch(ex => {
            console.log(ex)
            // console.log(ex.response.status)
            this.dialog.alertText = ex.response.data.message;
            this.dialog.alert = true;
          });

    },


    getDomains: async function () {
      let isSuccess = {flag: false, code: 400, msg: ''};
      await axios
          .get(`/app/common/setting/domains`,
              {
                params: {},
              })
          .then(response => {
            console.log(response)
            if (response.status === 200) {
              // 사용가능
              isSuccess.flag = true;

              this.gameDetailList[id] = response.data;

            } else {
              isSuccess.flag = false;
              isSuccess.msg = "게임을 불러오기 오류.";
            }
            isSuccess.code = response.status;
          })
          .catch(ex => {
            console.warn("ERROR!!!!! : ", ex);
            isSuccess.flag = false;
            isSuccess.code = ex.response.status;
            isSuccess.msg = ex.response.data.message;
          })

      if (isSuccess.flag) {
        // if (this.$vuetify.breakpoint.lgAndUp) {
        //   this.$refs.matchList.openDetail(id)
        // } else {
        //
        //   this.$refs.matchListMobile.openDetail(id)
        // }
      } else {
        this.dialog.snackBar = false;
        this.dialog.snackBarText = '';
        if (isSuccess.code === 400) {
          this.dialog.alertText = isSuccess.msg;
          this.dialog.alert = true;
        } else if (isSuccess.code === 401) {
          let refreshTokenResult = await this.$refreshToken()
          if (refreshTokenResult.flag) {
            await this.getDomains()
          } else {
            if (refreshTokenResult.status === 403) {
              this.dialog.alertActionType = 'logout'
              this.dialog.alertOption.persistent = true
              this.dialog.alertText = refreshTokenResult.msg
            } else {
              this.dialog.alertText = refreshTokenResult.msg
            }
            this.dialog.alert = true;

          }

        } else if (isSuccess.code === 403) {
          this.dialog.alert = true;
          this.dialog.alertText = isSuccess.msg;
          this.dialog.alertActionType = 'logout'
          this.dialog.alertOption.persistent = true
        } else {
          this.dialog.alertText = '게임 불러오기 오류.';
          this.dialog.alert = true;
        }
      }

    },
    checkSiteConfig: async function () {
      let result = await this.$updateSiteInfo()
      console.log(result)
      if (result.underMaintenance) {
        this.dialog.underMaintenance = true
        console.log(result.constructionText)
        if (result.constructionText.length > 0) {
          this.dialog.underMaintenanceText = result.constructionText
        } else {
          this.dialog.underMaintenanceText = '사이트 점검 중이므로 이용하실 수 없습니다.';
        }
      }
    }
  },
  mounted() {
    if (this.$route.query.code !== '' && this.$route.query.code) {
      this.openJoinDialog()
    }
    console.log('refreshTokenFlag',this.$refreshTokenFlag)
    this.checkSiteConfig();
    // this.getDomains()
  },
  created() {
    this.$eventBusInitAlert()
  },
  beforeCreate: function() {

    if (this.$vuetify.breakpoint.lgAndUp) {
      document.body.className = 'loginBg';
    }
    else {
      document.body.className = 'loginBg_mobile';
    }

  },
  watch: {
    dialog: {
      handler: function (val, oldVal) {
        if (this.dialog.alert) {
          this.showAlert()
        }
      },
      deep: true

    }
  }
}
</script>

<style scoped>
.mainLogo {
  padding: 80px 0;
}
div ::v-deep .v-text-field--outlined.searchInput > .v-input__control > .v-input__slot {
  border: 1px solid rgb(59, 74, 101) !important;
  border-radius: 0.3rem !important;
}
</style>
